"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function create(real, imaginary) {
    return {
        real: real,
        imaginary: imaginary,
    };
}
exports.create = create;
function log(value) {
    return {
        real: Math.log(abs(value)),
        imaginary: Math.atan2(value.imaginary, value.real),
    };
}
exports.log = log;
function negate(value) {
    return {
        real: -value.real,
        imaginary: -value.imaginary,
    };
}
exports.negate = negate;
function subtract(left, right) {
    return subtractInternal(ensureComplex(left), ensureComplex(right));
}
exports.subtract = subtract;
function add(left, right) {
    return addInternal(ensureComplex(left), ensureComplex(right));
}
exports.add = add;
function multiply(left, right) {
    return multiplyInternal(ensureComplex(left), ensureComplex(right));
}
exports.multiply = multiply;
function divide(left, right) {
    return divideInternal(ensureComplex(left), ensureComplex(right));
}
exports.divide = divide;
function subtractInternal(left, right) {
    return {
        real: left.real - right.real,
        imaginary: left.imaginary - right.imaginary,
    };
}
function addInternal(left, right) {
    return {
        real: left.real + right.real,
        imaginary: left.imaginary + right.imaginary,
    };
}
function multiplyInternal(left, right) {
    return {
        real: left.real * right.real - left.imaginary * right.imaginary,
        imaginary: left.imaginary * right.real + left.real * right.imaginary,
    };
}
function divideInternal(left, right) {
    var num1 = left.real;
    var num2 = left.imaginary;
    var num3 = right.real;
    var num4 = right.imaginary;
    if (Math.abs(num4) < Math.abs(num3)) {
        var num5 = num4 / num3;
        return {
            real: (num1 + num2 * num5) / (num3 + num4 * num5),
            imaginary: (num2 - num1 * num5) / (num3 + num4 * num5),
        };
    }
    else {
        var num5 = num3 / num4;
        return {
            real: (num2 + num1 * num5) / (num4 + num3 * num5),
            imaginary: (-num1 + num2 * num5) / (num4 + num3 * num5),
        };
    }
}
function abs(value) {
    if (isInfinity(value.real) || isInfinity(value.imaginary)) {
        return Number.POSITIVE_INFINITY;
    }
    var num1 = Math.abs(value.real);
    var num2 = Math.abs(value.imaginary);
    if (num1 > num2) {
        var num3 = num2 / num1;
        return num1 * Math.sqrt(1.0 + num3 * num3);
    }
    else {
        if (num2 === 0.0) {
            return num1;
        }
        var num3 = num1 / num2;
        return num2 * Math.sqrt(1.0 + num3 * num3);
    }
}
function isInfinity(value) {
    return value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY;
}
function ensureComplex(value) {
    if (typeof value === "number") {
        return create(value, 0);
    }
    return value;
}
